import 'vant/lib/index.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Button,DropdownMenu,DropdownItem,Cell,CellGroup,Switch,Field,Dialog,Toast,ImagePreview,Empty,Popup,Divider} from 'vant'
import { RadioGroup, Radio } from 'vant';
import { CheckboxGroup, Checkbox } from 'vant';
import { Tab, Tabs } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { NavBar, Icon, Tag } from 'vant';
import { DatetimePicker } from 'vant';
import { Picker } from 'vant';
import { Overlay } from 'vant';

Vue.component('van-field', Field)
Vue.component('van-button', Button)
Vue.component('van-dropdown-menu', DropdownMenu)
Vue.component('van-dropdown-item', DropdownItem)
Vue.component('van-cell', Cell)
Vue.component('van-cell-group', CellGroup)
Vue.component('van-switch', Switch)
Vue.component('van-checkbox-group', CheckboxGroup)
Vue.component('van-checkbox', Checkbox)
Vue.component('van-radio-group', RadioGroup)
Vue.component('van-radio', Radio)
Vue.component('van-tab', Tab)
Vue.component('van-tabs', Tabs)
Vue.component('van-tabbar', Tabbar)
Vue.component('van-tabbar-item', TabbarItem)
Vue.component('van-nav-bar', NavBar)
Vue.component('van-icon', Icon)
Vue.component('van-tag', Tag)
Vue.component('van-empty', Empty)
Vue.component('van-popup', Popup)
Vue.component('van-divider', Divider)
Vue.component('van-dialog', Dialog.Component)
Vue.component('van-datetime-picker', DatetimePicker)
Vue.component('van-picker', Picker)
Vue.component('van-overlay', Overlay)

Vue.prototype.$dialog = Dialog
Vue.prototype.$toast = Toast
Vue.prototype.$imagePreview = ImagePreview
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 获取哀悼模式状态
const MOURN_API_URL = process.env.VUE_APP_API_BASE_URL + '/api/index/getMournEnabled'
fetch(MOURN_API_URL).then(response => response.json()).then(data => {
  if (data.code === 200 && data.data === true) {
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.style.webkitFilter = 'grayscale(100%)'
      appElement.style.mozFilter = 'grayscale(100%)'
      appElement.style.msFilter = 'grayscale(100%)'
      appElement.style.oFilter = 'grayscale(100%)'
      appElement.style.filter = 'grayscale(100%)'
      appElement.style.filter = 'progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)'
    }
  }
}).catch(error => {
  console.error('获取哀悼模式状态失败:', error)
})
